const VaultDB = {
     Newsletter : [
         {
             name: "tanaypratap's letters",
             desc: "Tanay is the mentor you always wanted. He wont give up on your neiher he will let you give up on yourself. Tanay with his newsletter shares his knowledge, wisdom and experience helping you advance in your career in tech.",
             link: "https://tanaypratap.substack.com",
             action:"Subscribe Now"
         },
         {
            name: "Varun Mayya Premium",
            desc: "This is a private newsletter by Varun Mayya where he put forwards a in depth ultimate guide to millennials, including but not limited to start-ups, tech, business, etc giving you an unfair advantage. ",
            link: "https://varunmayya.com",
            action:"Subscribe Now"

         },
         {
            name: "3-2-1 Thursday",
            desc: "James Clear pens down the most wisdom per word of any newsletter on the web by providing self improvement tips for folks who are on a quest to live a healthy life",
            link: "https://jamesclear.com/3-2-1",
            action:"Subscribe Now"
         },
         {   
             name:"warikoo Wanderings",
             desc:"Every Friday, before the weekend unwinds, Ankur Warikoo sends out a free flowing newsletter, which is a sneak peek of what’s on his mind, the books and videos he found fascinating, quotable quotes, interesting people he met and a interesting poll at the end for the readers.",
             link:"https://ankurwarikoo.com/newsletter",
             action:"Subscribe Now"
         },
           { name:"Daily Stoic",
            desc:"A daily medicine to soul designed to help you cultivate strength, insight, and wisdom to live your best life.",
            link:"https://dailystoic.com/",
            action:"Subscribe Now"
        },

        {
                name:"Monday Musings and Friday Finds",
                desc:"David Perell funnel into utility over interestingness and urgency over importance, and the timely over the timeless. Each edition will be fresh and worthy of your attention; and is a break from the rest of the news-obsessed Internet.",
                link:"https://perell.com/newsletter/",
                action:"Subscribe Now"
        },

        {
                name:"Flow Research Collective",
                desc: "Steven Kotler helps you to accomplish your wildest professional goals while reclaiming time, space, and freedom in your personal life. In this newsletter, he pens down peak performance tips to help you spend more time in flow immediately.",
                link:"https://www.stevenkotler.com/about",
                action:"Subscribe Now"
        }

     ],
     Podcasts: [
         {
             name:"Podcast By Naval Ravikant",
             desc:"Naval Ravikant is the CEO and co-founder of AngelList.He is often called by the title 'The Angel Philospher. Naval is an incredibly deep thinker who challenges the status quo on so many things. In his podcast he shares his wisdom and knowledge on mindfulness, science, tech world and pursuing wealth and happiness. ",
             link:"https://nav.al",
             action:"Listen Now"
         },
         {
             name:"The Tim Ferris Show",
             desc:"In each episode, Tim deconstruct world-class performers from eclectic areas (investing, sports, business, art, etc.) to extract the tactics, tools, and routines you can use. This includes favorite books, morning routines, exercise habits, time-management tricks, and much more",
             link:"https://tim.blog/podcast/",
             action:"Listen Now"
         },
         {
            name:"Making Sense Podcast",
            desc:"A neuroscientist, philosopher, and best-selling author Sam Harris explores important questions about the human mind, society, and current events in podcast with expert from different domains",
            link:"https://samharris.org/podcast/",
            action:"Listen Now"
        },         {
            name:"Huberman Lab Podcast",
            desc:"Professor of Neurobiology and Ophthalmology at Stanford University School of Medicine Dr. Andrew Huberman discusses neuroscience—how our brain and its connections with the organs of our body controls our perceptions, our behaviors, and our health. ",
            link:"https://hubermanlab.com/follow/",
            action:"Listen Now"
        },   
              {
            name:"The Psychology Podcast",
            desc:"Dr.Scott Barry Kaufman is a cognitive scientist and humanistic psychologist exploring the mind, creativity, and the depths of human potential. In each episode he talks with inspiring and thought-provoking guests who will stimulate your mind, and give you a greater understanding of yourself, others, and the world we live in. ",
            link:"https://scottbarrykaufman.com/podcast/",
            action:"Listen Now",
        },
        {
            name:"The Knowledge Project Podcast",
            desc:"A podcast about mastering the best of what other people have already figured out.The Knowledge Project focuses on insights and lessons that never expire. You’ll walk away from every episode with actionable insights that help you get better results and live a more meaningful life.",
            link:"https://fs.blog/knowledge-project/",
            action:"Listen Now",
        }
     ],
    Blogs: [
        {
            name:"Essays By Paul Graham",
            desc:"One of the most famous person of Silicon Valley Paul Graham's essays are goldmine of all the wisdom and knowledge he possesses. His essays will give you perspective of on so many different aspect of your life. Must Read",
            link:"http://www.paulgraham.com/articles.html",
            action:"Read Now"
        },
        {
            name:"Articles By Mark Manson",
            desc:"Mark Manson the New York Times best selling author with his articles shares life advice on personal values, emotional intelligence, relationships, finding purpose, and much more.",
            link:"https://markmanson.net/best-articles",
            action:"Read Now"
        },
        {
            name:"Articles by Farnam Street",
            desc:"Articles about enduring topics like making better decisions, accelerating learning, and more. You’ll also find articles explaining how to use mental models, how to read better, and finding your purpose.",
            link:"https://fs.blog/start/",
            action:"Read Now"
        },
        {
            name:"Blogs By Flow Research Collective ",
            desc:"The Flow Reserach Collective organisation with the mission to understand the science behind ultimate human performance and use it to train up individuals and organizations has an amazong collection of blogs on topic ranging from flow, leadership and technology helping you to get insight on how to work at your peek performance.",
            link:"https://www.flowresearchcollective.com/blog",
            action:"Read Now"
        }
    ]



}
export default VaultDB

